import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ForcedInclusionType } from '../../model/forced-inclusion-type';

@Component({
  selector: 'av-forced-inclusion-type-multi-select',
  templateUrl: './av-forced-inclusion-type-multi-select.component.html',
  styleUrls: ['./av-forced-inclusion-type-multi-select.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AvForcedInclusionTypeMultiSelectComponent),
      multi: true
    }
  ]
})
export class AvForcedInclusionTypeMultiSelectComponent implements OnInit, ControlValueAccessor {
  @Input() filter: boolean;
  @Input() disabled: boolean;
  @Input() label: string;

  options: any[] = [];
  selectedItems: ForcedInclusionType[] = [];

  private onChange: (value: any) => void = () => { };
  private onTouched: () => void = () => { };

  constructor(private readonly translateService: TranslateService) { }

  ngOnInit() {
    this.getFileType();
  }

  getFileType() {
    this.options = [];
    this.options.push({ label: this.translateService.instant('module.forcedInclusionType.noInclusion', "moduleName"), value: "module.forcedInclusionType.noInclusion" });
    this.options.push({ label: this.translateService.instant('module.forcedInclusionType.forcedInclusion', "moduleName"), value: "module.forcedInclusionType.forcedInclusion" });
    this.options.push({ label: this.translateService.instant('module.forcedInclusionType.immobilization', "moduleName"), value: "module.forcedInclusionType.immobilization" });
    this.options.push({ label: this.translateService.instant('module.forcedInclusionType.Apprehension', "moduleName"), value: "module.forcedInclusionType.Apprehension" });
    this.options.push({ label: this.translateService.instant('module.forcedInclusionType.mobilization', "moduleName"), value: "module.forcedInclusionType.mobilization" });
  }

  onSelectionChange(event: any) {
    this.selectedItems = event.value;
    this.onChange(this.selectedItems);
  }

  // ControlValueAccessor implementation
  writeValue(value: any): void {
    this.selectedItems = value || [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}